import { Link } from "react-router-dom";
import { ArrowUpRight, Download, Phone, Mail, Globe } from "lucide-react";
import { NAV, CONTACT } from "../../data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-navy text-white">
      <div className="mx-auto max-w-[1400px] px-5 py-16 sm:px-8">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img src="/vbg-bridge-mark-t.png" alt="VectorBridge Group" draggable={false} className="pointer-events-none h-11 w-auto select-none brightness-0 invert" />
              <span className="flex flex-col leading-none">
                <span className="font-display text-xl font-bold uppercase tracking-tight text-white">VectorBridge</span>
                <span className="mt-1 font-mono text-[9px] uppercase tracking-[0.3em] text-white/60">Group, LLC</span>
              </span>
            </div>

            <p className="mt-7 font-display text-2xl font-light tracking-tight">
              Building <span className="text-lightblue">Bridges.</span><br />
              Delivering <span className="text-lightblue">Results.</span>
            </p>

            <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/60">
              Government contracting, staffing, and business solutions for government, defense,
              healthcare, and commercial enterprises nationwide.
            </p>

            <a
              href="/VectorBridge-Capability-Statement.pdf"
              download
              data-testid="footer-capability-download"
              className="mt-8 inline-flex items-center gap-2 border border-white/25 px-4 py-3 font-mono text-[11px] uppercase tracking-[0.15em] text-white transition-colors hover:border-lightblue hover:text-lightblue"
            >
              <Download size={14} /> Capability Statement
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-lightblue">Navigate</div>
            <ul className="mt-5 space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="link-underline text-sm text-white/70 hover:text-white">{n.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-lightblue">Contact</div>
            <ul className="mt-5 space-y-4 text-sm">
              <li>
                <a className="group flex items-center gap-3 text-white/80 hover:text-white" href={`tel:${CONTACT.phone}`}>
                  <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-white/10 text-lightblue transition-colors group-hover:bg-lightblue group-hover:text-navy"><Phone size={14} /></span>
                  {CONTACT.phone}
                </a>
              </li>
              <li>
                <a className="group flex items-center gap-3 text-white/80 hover:text-white" href={`mailto:${CONTACT.email}`}>
                  <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-white/10 text-lightblue transition-colors group-hover:bg-lightblue group-hover:text-navy"><Mail size={14} /></span>
                  {CONTACT.email}
                </a>
              </li>
              <li>
                <a className="group flex items-center gap-3 text-white/80 hover:text-white" href="https://vectorbridgegroup.com">
                  <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-white/10 text-lightblue transition-colors group-hover:bg-lightblue group-hover:text-navy"><Globe size={14} /></span>
                  vectorbridgegroup.com
                </a>
              </li>
            </ul>
            <Link
              to="/contact"
              data-testid="footer-contact-cta"
              className="group mt-7 inline-flex items-center gap-1 font-display text-xl tracking-tight hover:text-lightblue"
            >
              Start a conversation <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
            <div className="mt-6 space-y-1 border-t border-white/15 pt-4 font-mono text-[10px] uppercase leading-relaxed tracking-[0.14em] text-white/55">
              <div>{CONTACT.address}</div>
              <div>UEI {CONTACT.uei} · CAGE {CONTACT.cage}</div>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-white/15 pt-6 font-mono text-[11px] uppercase tracking-[0.15em] text-white/60 sm:flex-row sm:items-center sm:justify-between">
          <span>© {new Date().getFullYear()} VectorBridge Group LLC</span>
          <div className="flex flex-wrap items-center gap-5">
            <Link to="/client-portal" className="transition-colors hover:text-white" data-testid="footer-client-portal">Client Portal</Link>
            <Link to="/candidate-portal" className="transition-colors hover:text-white" data-testid="footer-candidate-portal">Candidate Portal</Link>
            <Link to="/admin/login" className="transition-colors hover:text-lightblue" data-testid="footer-admin-login">Staff Login</Link>
          </div>
          <span>Equal Opportunity Employer</span>
        </div>
      </div>
    </footer>
  );
}
